




















































































































import Draggable from 'vuedraggable'
import DisplayItem from './DisplayItem.vue'
import partition from '@/helpers/partition'
import { ProductImageInterface } from '@/types/definitions/ProductImageInterface'
import ImageGalleryItem from './ImageGalleryItem.vue'
import DragAndDropMove from '@/mixins/drag-and-drop-move'
import addFontAwesomeIcon from '@/helpers/add-font-awesome-icon'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'

addFontAwesomeIcon(faExternalLinkAlt)

@Component({ components: { DisplayItem, ImageGalleryItem, Draggable } })
export default class ImageGallerySpecialDropSlot extends Mixins(
	DragAndDropMove
) {
	@Prop({ required: true })
	readonly image: ProductImageInterface | undefined

	@Prop({ required: true, type: Array })
	readonly categories: Category

	@Prop({ required: true, type: String })
	readonly title: String

	@Prop({ required: true, type: String })
	readonly color: String

	get list() {
		return this.image ? [this.image] : []
	}

	set list(_images: ProductImageInterface[]) {
		// Just relax ...
	}

	get isMeasurementsSlot() {
		return (
			this.categories[0] === 'special' &&
			this.categories[1] === 'measurements'
		)
	}

	get canUsePreset() {
		return (
			this.isMeasurementsSlot &&
			!!this.image &&
			!this.image.isPreset &&
			!!this.$store.getters.measurementPreset
		)
	}

	/**
	 * Switches the slot from a photo set by hand back to the preset
	 * measurement image, including the platforms that use the photo as their
	 * measurements image.
	 */
	async usePreset(image: ProductImageInterface) {
		const { categories, categorizedManually } = image

		this.$store.commit('images/RESET_CATEGORIES', image)

		const presetImage = await this.$store.dispatch(
			'images/LOAD_PRESET_IMAGE'
		)

		if (!presetImage) {
			// The preset image could not be loaded, so keep the photo
			this.$store.commit('images/UPDATE_IMAGE', {
				id: image.id,
				categories,
				categorizedManually
			})

			return
		}

		this.$store.dispatch('platforms/REPLACE_MEASUREMENTS_IMAGE', {
			previousImageId: image.id,
			newImageId: presetImage.id
		})
	}

	remove(image) {
		this.$store.commit('images/RESET_CATEGORIES', image)

		// Fall back to the preset measurement image, if there is one
		if (this.isMeasurementsSlot) {
			this.$store.dispatch('images/LOAD_PRESET_IMAGE')
		}
	}

	add(e) {
		const newImage = this.getImageById(e.item.dataset.imageId)
		const previousImage = this.image

		if (previousImage && previousImage.isPreset) {
			// A photo dropped onto the slot overrides the preset image. It is
			// not moved to the photo's previous category, so it cannot end up
			// in the gallery or the platforms' filler images.
			this.$store.commit('images/DELETE_IMAGE', previousImage)
		} else if (previousImage) {
			this.$store.commit('images/UPDATE_IMAGE', {
				id: previousImage.id,
				order: newImage.order,
				categories: newImage.categories,
				categorizedManually: newImage.categorizedManually
			})
		}

		this.$store.commit('images/UPDATE_IMAGE', {
			id: newImage.id,
			order: 0,
			categories: this.categories,
			categorizedManually: true
		})

		if (previousImage && previousImage.isPreset) {
			this.$store.dispatch(
				'platforms/RESET_IMAGE_OCCURRENCES_FOR_IMAGE',
				{ previousImageId: previousImage.id, newImageId: newImage.id }
			)
		}
	}
}
